import { Theme } from '@mui/material';
import { helixDark, helixLight } from '@signanthealth/modular-ui';

/**
 * Get the application theme based on the configured theme name.
 *
 * Uses helixLight/helixDark from @signanthealth/modular-ui.
 * Falls back to the provided theme (from useThemeSwitcher).
 */
export const getTheme = (
  themeName: string | null,
  fallbackTheme: Theme
): Theme => {
  return themeName ? (themeName === 'light' ? helixLight : helixDark) : fallbackTheme;
};
